export default [
  { to: 'medicinska_riktlinjer', title: 'Medicinska riktlinjer' },
  { to: 'lakemedel', title: 'Läkemedel' },
  { to: 'rutiner', title: 'Rutiner' },
  { to: 'info', title: 'Info' },
  { to: 'arkiv', title: 'Arkiv' },
];
